import { render, staticRenderFns } from "./TemplateSetting.vue?vue&type=template&id=c627a9b0&scoped=true&"
import script from "./TemplateSetting.vue?vue&type=script&lang=js&"
export * from "./TemplateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c627a9b0",
  null
  
)

export default component.exports